import { ValidationProps, ValidationLevel } from 'ui/common/validation/types';

export const hasTranslationsValid = (
  validation: ValidationProps,
  mainLanguage: number
): boolean => {

  const validationMessages =
    validation?.level === ValidationLevel.error &&
      !!validation?.messages
      ? validation.messages
      : [];

  return !validationMessages || validationMessages
    .filter(message => message.parameters &&
      Object.keys(message.parameters)
        .some(key => message.parameters[key] !== mainLanguage)
    ).length === 0;
};
